import { SWRConfiguration } from 'swr';

import { useSWR } from '~/hooks/useSWR';
import { fetchFromOldApi } from '~/services/Http';
import { AppModules } from '~/services/Permissions';

import { useModulesConfig } from '../company';

import { CustomFieldValues } from './types';

export const getCustomEmployeeFields = (
  id: string,
): Promise<CustomFieldValues> => {
  return fetchFromOldApi(`/json/customdata/EMPLOYEE/${id}`).then((r) =>
    r.json(),
  );
};

export const useCustomEmployeeData = (
  employeeId: number,
  swrConfig?: SWRConfiguration,
  isDisabled?: boolean,
) => {
  const { isModuleEnabled } = useModulesConfig();
  const isCustomDataEnabled = isModuleEnabled(AppModules.CUSTOM_DATA);

  const { data, isLoading, error } = useSWR<CustomFieldValues>(
    !!employeeId && !isDisabled && isCustomDataEnabled
      ? ['getCustomEmployeeFields', employeeId]
      : null,
    () => getCustomEmployeeFields(String(employeeId)),
    swrConfig,
  );

  return {
    data,
    isLoading,
    error,
  };
};
